import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Image, Link } from 'pcln-design-system'

const StyledImage = styled(Image)`
  height: 100%;
`
StyledImage.displayName = 'StyledImage'

const LogoLink = styled(Link)`
  display: contents;
  z-index: 10;
  height: 100%;
`
LogoLink.displayName = 'LogoLink'

function NavLogo ({ className, title, path, href, target, color }) {
  const logo = <StyledImage title={title} src={path} data-testid='nav-logo' />

  return href ? (
    <LogoLink
      href={href}
      color={color}
      target={target}
      rel='noopener'
      data-testid='nav-logo'
    >
      {logo}
    </LogoLink>
  ) : (
    logo
  )
}

NavLogo.displayName = 'NavLogo'

NavLogo.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  color: PropTypes.string
}

NavLogo.defaultProps = {
  className: ''
}

export default memo(NavLogo)
